import { render, staticRenderFns } from "./floorElevator.vue?vue&type=template&id=f2a7d1c6&scoped=true"
import script from "./floorElevator.vue?vue&type=script&lang=js"
export * from "./floorElevator.vue?vue&type=script&lang=js"
import style0 from "./floorElevator.vue?vue&type=style&index=0&id=f2a7d1c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a7d1c6",
  null
  
)

export default component.exports